<div class="revisions-log">
  <div class="revisions-log__table-wrapper">
    <table
      class="revisions-log__table"
      aria-label="Revisions"
      mat-table
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="revisionIndex">
        <th
          *matHeaderCellDef
          class="revisions-log__column--revision-index"
          mat-header-cell
        >
          Revision
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          <a
            class="text-link"
            [routerLink]="['/', entity.number]"
          >
            Revision {{ entity.revisionIndex }}
          </a>
        </td>
      </ng-container>
      <ng-container matColumnDef="statusName">
        <th
          *matHeaderCellDef
          class="revisions-log__column--status-name"
          mat-header-cell
        >
          Status
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          <procure-status-badge [status]="entity.status" />
        </td>
      </ng-container>
      <ng-container matColumnDef="created">
        <th
          *matHeaderCellDef
          class="revisions-log__column--created"
          mat-header-cell
        >
          Date
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          {{ entity.created | date }}
        </td>
      </ng-container>
      <tr *matNoDataRow>
        <td [attr.colspan]="displayedColumns.length">There are no revisions.</td>
      </tr>
      <tr
        *matHeaderRowDef="displayedColumns"
        mat-header-row
      ></tr>
      <tr
        *matRowDef="let row; columns: displayedColumns"
        mat-row
      ></tr>
    </table>
  </div>
</div>
